// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file client/notifications.proto (package client, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Pagination } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { NotificationMessage } from "../common/notification_pb";
import { file_common_notification } from "../common/notification_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file client/notifications.proto.
 */
export const file_client_notifications: GenFile = /*@__PURE__*/
  fileDesc("ChpjbGllbnQvbm90aWZpY2F0aW9ucy5wcm90bxIGY2xpZW50IoABChhMaXN0Tm90aWZpY2F0aW9uc1JlcXVlc3QSGAoLdW5yZWFkX29ubHkYASABKAhIAIgBARIrCgpwYWdpbmF0aW9uGAIgASgLMhIuY29tbW9uLlBhZ2luYXRpb25IAYgBAUIOCgxfdW5yZWFkX29ubHlCDQoLX3BhZ2luYXRpb24ihAEKGUxpc3ROb3RpZmljYXRpb25zUmVzcG9uc2USKQoEZGF0YRgBIAMoCzIbLmNvbW1vbi5Ob3RpZmljYXRpb25NZXNzYWdlEiYKCnBhZ2luYXRpb24YAiABKAsyEi5jb21tb24uUGFnaW5hdGlvbhIUCgx1bnJlYWRfY291bnQYAyABKAUiKwocTWFya05vdGlmaWNhdGlvbnNSZWFkUmVxdWVzdBILCgNpZHMYASADKAkiMAodTWFya05vdGlmaWNhdGlvbnNSZWFkUmVzcG9uc2USDwoHdXBkYXRlZBgBIAEoBSIhCh9NYXJrQWxsTm90aWZpY2F0aW9uc1JlYWRSZXF1ZXN0IjMKIE1hcmtBbGxOb3RpZmljYXRpb25zUmVhZFJlc3BvbnNlEg8KB3VwZGF0ZWQYASABKAUyyAIKF05vdGlmaWNhdGlvbnNSUENTZXJ2aWNlElgKEUxpc3ROb3RpZmljYXRpb25zEiAuY2xpZW50Lkxpc3ROb3RpZmljYXRpb25zUmVxdWVzdBohLmNsaWVudC5MaXN0Tm90aWZpY2F0aW9uc1Jlc3BvbnNlEmQKFU1hcmtOb3RpZmljYXRpb25zUmVhZBIkLmNsaWVudC5NYXJrTm90aWZpY2F0aW9uc1JlYWRSZXF1ZXN0GiUuY2xpZW50Lk1hcmtOb3RpZmljYXRpb25zUmVhZFJlc3BvbnNlEm0KGE1hcmtBbGxOb3RpZmljYXRpb25zUmVhZBInLmNsaWVudC5NYXJrQWxsTm90aWZpY2F0aW9uc1JlYWRSZXF1ZXN0GiguY2xpZW50Lk1hcmtBbGxOb3RpZmljYXRpb25zUmVhZFJlc3BvbnNlYgZwcm90bzM", [file_common_common, file_common_notification]);

/**
 * @generated from message client.ListNotificationsRequest
 */
export type ListNotificationsRequest = Message<"client.ListNotificationsRequest"> & {
  /**
   * @generated from field: optional bool unread_only = 1;
   */
  unreadOnly?: boolean;

  /**
   * @generated from field: optional common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.ListNotificationsRequest.
 * Use `create(ListNotificationsRequestSchema)` to create a new message.
 */
export const ListNotificationsRequestSchema: GenMessage<ListNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_client_notifications, 0);

/**
 * @generated from message client.ListNotificationsResponse
 */
export type ListNotificationsResponse = Message<"client.ListNotificationsResponse"> & {
  /**
   * @generated from field: repeated common.NotificationMessage data = 1;
   */
  data: NotificationMessage[];

  /**
   * @generated from field: common.Pagination pagination = 2;
   */
  pagination?: Pagination;

  /**
   * @generated from field: int32 unread_count = 3;
   */
  unreadCount: number;
};

/**
 * Describes the message client.ListNotificationsResponse.
 * Use `create(ListNotificationsResponseSchema)` to create a new message.
 */
export const ListNotificationsResponseSchema: GenMessage<ListNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_client_notifications, 1);

/**
 * @generated from message client.MarkNotificationsReadRequest
 */
export type MarkNotificationsReadRequest = Message<"client.MarkNotificationsReadRequest"> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];
};

/**
 * Describes the message client.MarkNotificationsReadRequest.
 * Use `create(MarkNotificationsReadRequestSchema)` to create a new message.
 */
export const MarkNotificationsReadRequestSchema: GenMessage<MarkNotificationsReadRequest> = /*@__PURE__*/
  messageDesc(file_client_notifications, 2);

/**
 * @generated from message client.MarkNotificationsReadResponse
 */
export type MarkNotificationsReadResponse = Message<"client.MarkNotificationsReadResponse"> & {
  /**
   * @generated from field: int32 updated = 1;
   */
  updated: number;
};

/**
 * Describes the message client.MarkNotificationsReadResponse.
 * Use `create(MarkNotificationsReadResponseSchema)` to create a new message.
 */
export const MarkNotificationsReadResponseSchema: GenMessage<MarkNotificationsReadResponse> = /*@__PURE__*/
  messageDesc(file_client_notifications, 3);

/**
 * @generated from message client.MarkAllNotificationsReadRequest
 */
export type MarkAllNotificationsReadRequest = Message<"client.MarkAllNotificationsReadRequest"> & {
};

/**
 * Describes the message client.MarkAllNotificationsReadRequest.
 * Use `create(MarkAllNotificationsReadRequestSchema)` to create a new message.
 */
export const MarkAllNotificationsReadRequestSchema: GenMessage<MarkAllNotificationsReadRequest> = /*@__PURE__*/
  messageDesc(file_client_notifications, 4);

/**
 * @generated from message client.MarkAllNotificationsReadResponse
 */
export type MarkAllNotificationsReadResponse = Message<"client.MarkAllNotificationsReadResponse"> & {
  /**
   * @generated from field: int32 updated = 1;
   */
  updated: number;
};

/**
 * Describes the message client.MarkAllNotificationsReadResponse.
 * Use `create(MarkAllNotificationsReadResponseSchema)` to create a new message.
 */
export const MarkAllNotificationsReadResponseSchema: GenMessage<MarkAllNotificationsReadResponse> = /*@__PURE__*/
  messageDesc(file_client_notifications, 5);

/**
 * @generated from service client.NotificationsRPCService
 */
export const NotificationsRPCService: GenService<{
  /**
   * @generated from rpc client.NotificationsRPCService.ListNotifications
   */
  listNotifications: {
    methodKind: "unary";
    input: typeof ListNotificationsRequestSchema;
    output: typeof ListNotificationsResponseSchema;
  },
  /**
   * @generated from rpc client.NotificationsRPCService.MarkNotificationsRead
   */
  markNotificationsRead: {
    methodKind: "unary";
    input: typeof MarkNotificationsReadRequestSchema;
    output: typeof MarkNotificationsReadResponseSchema;
  },
  /**
   * @generated from rpc client.NotificationsRPCService.MarkAllNotificationsRead
   */
  markAllNotificationsRead: {
    methodKind: "unary";
    input: typeof MarkAllNotificationsReadRequestSchema;
    output: typeof MarkAllNotificationsReadResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_client_notifications, 0);

